// 配置接口地址
export const api = {
  // 删除人脸名单
  deletePersonnelBwlist: '/vas/bwlist/deletePersonnelBwlist.json',
  // 查询名单
  queryPersonnelBwlist: '/vas/bwlist/queryPersonnelBwlist.json',
  // 上传图片
  batchFileload: '/common/file/batchFileload.json',
  // 新增名单
  addPersonnelBwlist: '/vas/bwlist/addPersonnelBwlist.json',
  // 修改名单
  updatePersonnelBwlist: '/vas/bwlist/updatePersonnelBwlist.json',
  // 删除名单组
  deleteFaceGroup: '/vas/faceGroup/deleteFaceGroup.json',
  // 新增名单组
  addFaceGroup: '/vas/faceGroup/addFaceGroup.json',
  // 修改名单组
  updateFaceGroup: '/vas/faceGroup/updateFaceGroup.json',
  // 查询名单组
  queryGroup: '/vas/faceGroup/queryFaceGroupByType.json',
  // 获取人员列表信息
  queryPersonList: 'vas/personnel/queryPersonList.json',
}
